import React from 'react'
import { Trans } from '@lingui/react'
import Link from 'redux-first-router-link'
import CenterBox from './CenterBox.js'

const submitAction = { type: 'formState/submit' }

const SubmitFailedPage = () => {
  return (
    <CenterBox>
      <Trans>
        We were unable to process your request. Please{' '}
        <Link to={submitAction}>try again</Link> later and contact
        support@remente.com if the problem persists.
      </Trans>
    </CenterBox>
  )
}

export default SubmitFailedPage



// WEBPACK FOOTER //
// ./src/components/SubmitFailedPage.js